var _ellipse, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvsLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 18,
    rx: 18,
    ry: 18,
    fill: "#EEF0F2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 18,
    rx: 18,
    ry: 18,
    fill: "#EEF0F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.0144 29.5227L26.4259 6.75822L41.7791 21.5815L21.5841 41.0784L10.0144 29.5227Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0137,
    y: 6.3501,
    width: 16.9412,
    height: 24.1086,
    rx: 1.36842,
    fill: "#CCD0D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0137,
    y: 5.69873,
    width: 16.2896,
    height: 24.1086,
    rx: 1.36842,
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1969 17.7533C14.1969 16.9169 14.8768 16.237 15.7132 16.237H17.6698V15.3076H15.7132C14.3632 15.3076 13.2676 16.4033 13.2676 17.7533C13.2676 19.1033 14.3632 20.1989 15.7132 20.1989H17.6698V19.2696H15.7132C14.8768 19.2696 14.1969 18.5897 14.1969 17.7533ZM16.2024 18.2424H20.1154V17.2641H16.2024V18.2424ZM20.6045 15.3076H18.648V16.237H20.6045C21.4409 16.237 22.1208 16.9169 22.1208 17.7533C22.1208 18.5897 21.4409 19.2696 20.6045 19.2696H18.648V20.1989H20.6045C21.9545 20.1989 23.0502 19.1033 23.0502 17.7533C23.0502 16.4033 21.9545 15.3076 20.6045 15.3076Z",
    fill: "#4788F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.0273,
    y1: 13.1941,
    x2: 31.7463,
    y2: 30.6171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18.1585,
    y1: 5.69873,
    x2: 18.1585,
    y2: 51.3096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvsLink);
export default __webpack_public_path__ + "static/media/cvs-link.5a66fe4f6b5d29b979e8f83dbed17ba3.svg";
export { ForwardRef as ReactComponent };